import React from 'react';
import { Users, TrendingUp, Target, Award, Briefcase, Clock, Euro, BarChart3 } from 'lucide-react';
import { BarChart, Bar, LineChart, Line, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
const teamStats = [{
  icon: Users,
  label: 'Membri del Team',
  value: '12',
  change: '+2 questo mese',
  trend: 'up'
}, {
  icon: TrendingUp,
  label: 'Performance Media',
  value: '87%',
  change: '+5% vs mese scorso',
  trend: 'up'
}, {
  icon: Target,
  label: 'Obiettivi Raggiunti',
  value: '34/40',
  change: '85% completamento',
  trend: 'up'
}, {
  icon: Euro,
  label: 'Revenue Totale',
  value: '€2.4M',
  change: '+18% vs mese scorso',
  trend: 'up'
}];
const monthlyPerformanceData = [{
  month: 'Gen',
  deals: 45,
  revenue: 850000
}, {
  month: 'Feb',
  deals: 52,
  revenue: 1200000
}, {
  month: 'Mar',
  deals: 48,
  revenue: 1100000
}, {
  month: 'Apr',
  deals: 61,
  revenue: 1450000
}, {
  month: 'Mag',
  deals: 58,
  revenue: 1650000
}, {
  month: 'Giu',
  deals: 67,
  revenue: 1890000
}];
const topPerformers = [{
  id: 1,
  name: 'Marco Rossi',
  role: 'Senior Sales Manager',
  deals: 23,
  revenue: 580000,
  performance: 95,
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop'
}, {
  id: 2,
  name: 'Laura Bianchi',
  role: 'Sales Manager',
  deals: 19,
  revenue: 520000,
  performance: 92,
  avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop'
}, {
  id: 3,
  name: 'Giuseppe Verdi',
  role: 'Sales Manager',
  deals: 17,
  revenue: 480000,
  performance: 88,
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop'
}, {
  id: 4,
  name: 'Sofia Romano',
  role: 'Junior Sales Manager',
  deals: 15,
  revenue: 420000,
  performance: 85,
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop'
}, {
  id: 5,
  name: 'Andrea Ferrari',
  role: 'Junior Sales Manager',
  deals: 12,
  revenue: 380000,
  performance: 82,
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop'
}];
const workloadDistribution = [{
  name: 'Trattative Attive',
  value: 45,
  color: '#1388ad'
}, {
  name: 'Follow-up',
  value: 28,
  color: '#3d9dbd'
}, {
  name: 'Nuove Opportunità',
  value: 18,
  color: '#6bb2cd'
}, {
  name: 'Chiusure',
  value: 12,
  color: '#10b981'
}];
const teamActivities = [{
  id: 1,
  member: 'Marco Rossi',
  action: 'ha chiuso una trattativa',
  detail: 'Via Montenapoleone 12 - €85K',
  time: '2 ore fa',
  type: 'success'
}, {
  id: 2,
  member: 'Laura Bianchi',
  action: 'ha avviato una nuova trattativa',
  detail: 'Corso Venezia 45 - Luxury Brand',
  time: '4 ore fa',
  type: 'info'
}, {
  id: 3,
  member: 'Giuseppe Verdi',
  action: 'ha programmato un incontro',
  detail: 'Designer Boutique - Domani 15:00',
  time: '5 ore fa',
  type: 'info'
}, {
  id: 4,
  member: 'Sofia Romano',
  action: 'ha inviato una proposta',
  detail: 'Via della Spiga 8 - €65K',
  time: '1 giorno fa',
  type: 'info'
}];
export function TeamDashboard() {
  const totalWorkload = workloadDistribution.reduce((sum, item) => sum + item.value, 0);
  return <div className="space-y-6" data-id="element-2957">
      <div className="flex items-center justify-between" data-id="element-2958">
        <div data-id="element-2959">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2960">
            Dashboard Team
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-2961">
            Panoramica performance e attività del team
          </p>
        </div>
      </div>
      {/* Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-2962">
        {teamStats.map((stat, index) => {
        const Icon = stat.icon;
        return <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-2963">
              <div className="p-3 border-b border-gray-200 bg-white" data-id="element-2964">
                <div className="flex items-center gap-2" data-id="element-2965">
                  <Icon className="w-4 h-4 text-[#1388ad]" data-id="element-2966" />
                  <h3 className="text-xs font-semibold text-gray-900" data-id="element-2967">
                    {stat.label}
                  </h3>
                </div>
              </div>
              <div className="p-4" data-id="element-2968">
                <div className="flex items-center justify-between mb-2" data-id="element-2969">
                  <p className="text-3xl font-semibold text-gray-900" data-id="element-2970">
                    {stat.value}
                  </p>
                  <span className="text-xs font-normal text-green-600 px-2 py-1 bg-green-50 rounded-full" data-id="element-2971">
                    {stat.change.split(' ')[0]}
                  </span>
                </div>
              </div>
            </div>;
      })}
      </div>
      {/* Charts Row */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-2972">
        {/* Performance Trend */}
        <div className="bg-white border border-gray-200 rounded-lg" data-id="element-2973">
          <div className="p-4 border-b border-gray-200" data-id="element-2974">
            <div className="flex items-center gap-2" data-id="element-2975">
              <TrendingUp className="w-5 h-5 text-[#1388ad]" data-id="element-2976" />
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-2977">
                Andamento Performance Team
              </h3>
            </div>
          </div>
          <div className="p-6" data-id="element-2978">
            <ResponsiveContainer width="100%" height={300} data-id="element-2979">
              <LineChart data={monthlyPerformanceData} data-id="element-2980">
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" data-id="element-2981" />
                <XAxis dataKey="month" stroke="#9ca3af" data-id="element-2982" />
                <YAxis stroke="#9ca3af" data-id="element-2983" />
                <Tooltip data-id="element-2984" />
                <Legend data-id="element-2985" />
                <Line type="monotone" dataKey="deals" stroke="#1388ad" strokeWidth={2} name="Trattative" data-id="element-2986" />
                <Line type="monotone" dataKey="revenue" stroke="#10b981" strokeWidth={2} name="Revenue" data-id="element-2987" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        {/* Workload Distribution */}
        <div className="bg-white border border-gray-200 rounded-lg" data-id="element-2988">
          <div className="p-4 border-b border-gray-200" data-id="element-2989">
            <div className="flex items-center gap-2" data-id="element-2990">
              <BarChart3 className="w-5 h-5 text-[#1388ad]" data-id="element-2991" />
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-2992">
                Distribuzione Carico di Lavoro
              </h3>
            </div>
          </div>
          <div className="p-6" data-id="element-2993">
            <div className="space-y-4" data-id="element-2994">
              {workloadDistribution.map((item, index) => {
              const percentage = (item.value / totalWorkload * 100).toFixed(1);
              return <div key={index} className="space-y-2" data-id="element-2995">
                    <div className="flex items-center justify-between" data-id="element-2996">
                      <span className="text-sm font-normal text-gray-900" data-id="element-2997">
                        {item.name}
                      </span>
                      <div className="flex items-center gap-3" data-id="element-2998">
                        <span className="text-sm font-normal text-gray-600" data-id="element-2999">
                          {item.value} attività
                        </span>
                        <span className="text-sm font-semibold text-[#1388ad] min-w-[45px] text-right" data-id="element-3000">
                          {percentage}%
                        </span>
                      </div>
                    </div>
                    <div className="w-full bg-gray-100 rounded-full h-2.5" data-id="element-3001">
                      <div className="h-2.5 rounded-full transition-all duration-500" style={{
                    width: `${percentage}%`,
                    backgroundColor: item.color
                  }} data-id="element-3002" />
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
      </div>
      {/* Top Performers and Recent Activities */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-3003">
        {/* Top Performers */}
        <div className="bg-white border border-gray-200 rounded-lg" data-id="element-3004">
          <div className="p-4 border-b border-gray-200" data-id="element-3005">
            <div className="flex items-center gap-2" data-id="element-3006">
              <Award className="w-5 h-5 text-[#1388ad]" data-id="element-3007" />
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-3008">
                Top Performers
              </h3>
            </div>
          </div>
          <div className="p-4" data-id="element-3009">
            <div className="space-y-3" data-id="element-3010">
              {topPerformers.map((performer, index) => <div key={performer.id} className="flex items-center gap-4 p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-3011">
                  <div className="flex items-center gap-3 flex-1" data-id="element-3012">
                    <div className="w-10 h-10 bg-[#1388ad]/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-3013">
                      <span className="text-sm font-semibold text-[#1388ad]" data-id="element-3014">
                        #{index + 1}
                      </span>
                    </div>
                    <img src={performer.avatar} alt={performer.name} className="w-10 h-10 rounded-full object-cover" data-id="element-3015" />
                    <div className="flex-1 min-w-0" data-id="element-3016">
                      <p className="text-sm font-semibold text-gray-900 truncate" data-id="element-3017">
                        {performer.name}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-3018">{performer.role}</p>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-3019">
                    <p className="text-sm font-semibold text-[#1388ad]" data-id="element-3020">
                      {performer.deals} deals
                    </p>
                    <p className="text-xs text-gray-500" data-id="element-3021">
                      €{(performer.revenue / 1000).toFixed(0)}K
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
        {/* Recent Activities */}
        <div className="bg-white border border-gray-200 rounded-lg" data-id="element-3022">
          <div className="p-4 border-b border-gray-200" data-id="element-3023">
            <div className="flex items-center gap-2" data-id="element-3024">
              <Clock className="w-5 h-5 text-[#1388ad]" data-id="element-3025" />
              <h3 className="text-sm font-semibold text-gray-900" data-id="element-3026">
                Attività Recenti
              </h3>
            </div>
          </div>
          <div className="p-4" data-id="element-3027">
            <div className="space-y-3" data-id="element-3028">
              {teamActivities.map(activity => <div key={activity.id} className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg" data-id="element-3029">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 ${activity.type === 'success' ? 'bg-green-100' : 'bg-blue-100'}`} data-id="element-3030">
                    {activity.type === 'success' ? <Target className={`w-4 h-4 ${activity.type === 'success' ? 'text-green-600' : 'text-blue-600'}`} data-id="element-3031" /> : <Briefcase className={`w-4 h-4 ${activity.type === 'success' ? 'text-green-600' : 'text-blue-600'}`} data-id="element-3032" />}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-3033">
                    <p className="text-sm font-normal text-gray-900" data-id="element-3034">
                      <span className="font-semibold" data-id="element-3035">{activity.member}</span>{' '}
                      {activity.action}
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-3036">
                      {activity.detail}
                    </p>
                    <p className="text-xs text-gray-400 mt-1" data-id="element-3037">
                      {activity.time}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}